import { useTranslation } from "react-i18next";
import { Button, SearchFieldTrigger } from "@akuna/ui";
import { Filter } from "lucide-react";

type Props = {
  activeCount: number;
  searchTerm: string;
  onOpen: () => void;
};

export function MobileFlowboardFilterChips({ activeCount, searchTerm, onOpen }: Props) {
  const { t } = useTranslation("calendar");
  return (
    <div className="flex w-full gap-2">
      <SearchFieldTrigger
        onClick={onOpen}
        className="min-w-0 flex-1"
        label={t("flowboardMobile.filters.search")}
        placeholder={t("flowboardMobile.filters.searchPlaceholder")}
        value={searchTerm}
      />
      <Button
        variant="outline"
        onClick={onOpen}
        className="shrink-0 gap-1.5 px-3.5 text-[13px] font-semibold"
      >
        <Filter className="h-3.5 w-3.5 text-muted-foreground" />
        {t("flowboardMobile.filters.title")}
        {activeCount > 0 ? (
          <span className="ml-0.5 rounded-full bg-primary px-1.5 text-[11px] font-bold text-primary-foreground">
            {activeCount}
          </span>
        ) : null}
      </Button>
    </div>
  );
}
